module.exports = __webpack_public_path__ + "img/user-info-icon.045c7a5f.png";